const mapStore = store => {
  return {
    id: store.id,
    name: store.name,
  }
}

const mapStoreGroup = store => {
  return {
    id: store.group.id,
    name: store.group.name,
    store: mapStore(store),
  }
}

const getUniqueGroups = groups => {
  const groupsById = new Map()

  groups.forEach(group => {
    if (!groupsById.has(group.id)) groupsById.set(group.id, group)
  })

  return [...groupsById.values()]
}

export const getUserGroupsFromStores = (stores, storeId) => {
  if (!stores?.length) return []

  const userStores = storeId ? stores.filter(store => store.id === storeId) : stores
  const groups = userStores.filter(store => store.group).map(mapStoreGroup)

  return getUniqueGroups(groups)
}

export const mergeGroups = (ownGroups, allGroups) => {
  if (!allGroups?.length) return ownGroups

  const allGroupsById = new Map(allGroups.map(group => [group.id, group]))
  const ownGroupIds = ownGroups.map(group => group.id)

  return [
    ...ownGroups.map(group => allGroupsById.get(group.id) || group),
    ...allGroups.filter(group => !ownGroupIds.includes(group.id)),
  ]
}
